interface MarketElement extends Element {
  componentOnReady: () => Promise<unknown>;
}

export default function (node: Node): node is MarketElement {
  const node_ = node as any;
  return node_?.tagName?.includes('MARKET-') && typeof node_.componentOnReady === 'function';
}
